import { BrowserModule } from "@angular/platform-browser";
import { NgModule, enableProdMode } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { AppComponent } from "./app.component";
import { UserService } from "./services/user.service";
import { HttpService } from "./services/http.service";
import { AuthService } from "./services/auth.service";
import { CacheService } from "./services/cache.service";
import { AuditService } from "./services/audit.service";
import { SubscriptionService } from "./services/subscriptions.service";
import { ProductsService } from "./services/products.service";
import { AccountAdminRoutingModule } from "./modules/account-admin-routing/account-admin-routing.module";
import { RestrictedComponent } from "./restricted/restricted.component";
import { LoginComponent } from "./login/login.component";
import { SharedModule } from "./modules/shared/shared.module";
import { CustomerService } from "./services/customer.service";
import { UnsavedStateService } from "./services/unsaved-state.service";
import { ProjectService } from "./services/project.service";
import { ServerTimeService } from "./services/server-time.service";
import { ErrorViewComponent } from "./error-view/error-view.component";
import { ClaimsService } from "./services/claims.service";
import { CustomPropertyService } from "./services/custom-property.service";
import { LocationsService } from "./services/locations.service";
import { TemplatesService } from "./services/templates.service";
import { ChoicesService } from "./services/choices.service";
import { AuthModule } from "@auth0/auth0-angular";
import { environment } from "../environments/environment";

const { authConfig } = environment;

@NgModule({
    declarations: [
        AppComponent,
        RestrictedComponent,
        ErrorViewComponent,
        LoginComponent,
    ],
    providers: [
        UserService,
        HttpService,
        AuthService,
        CacheService,
        AuditService,
        CustomerService,
        UnsavedStateService,
        ProjectService,
        ServerTimeService,
        ClaimsService,
        CustomPropertyService,
        SubscriptionService,
        ProductsService,
        LocationsService,
        TemplatesService,
        ChoicesService,
    ],
    imports: [
        SharedModule,
        BrowserModule,
        AccountAdminRoutingModule,
        HttpClientModule,
        AuthModule.forRoot({
            domain: authConfig.domain,
            clientId: authConfig.clientId,
            authorizationParams: {
                audience: authConfig.authorizationParams.audience,
                redirect_uri: authConfig.authorizationParams.redirect_uri,
            },
        }),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
